import React, { PropsWithChildren } from "react"
import { Popper as MuiPopper, PopperPlacementType, SxProps, Theme } from "@mui/material"

export type PrimitivePopperProps = PropsWithChildren<{
	open: boolean
	anchorEl: HTMLElement | null
	placement?: PopperPlacementType
	sx?: SxProps<Theme>
}>

export const PrimitivePopper = ({ children, ...props }: PrimitivePopperProps) => {
	return (
		<MuiPopper {...props}>
			{children}
		</MuiPopper>
	)
}
